import AppTheme from "../../../frontend/shared-theme/AppTheme";
import type { } from '@mui/x-date-pickers/themeAugmentation';
import type { } from '@mui/x-charts/themeAugmentation';
import type { } from '@mui/x-data-grid-pro/themeAugmentation';
import type { } from '@mui/x-tree-view/themeAugmentation';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { Container, Divider, Typography } from "@mui/material";
import { useColorScheme } from '@mui/material/styles';
import Footer from "../../../frontend/components/Footer";
import AppAppBar from "../../../frontend/components/AppAppBar";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

export default function AboutUs(props: { disableCustomTheme?: boolean }) {
  return (
    <AppTheme {...props}>
      <AboutUsContent />
    </AppTheme>
  )
}

function AboutUsContent() {
  const { mode, systemMode } = useColorScheme();

  return (
    <>
      <CssBaseline enableColorScheme />
      <Box sx={{ display: 'flex' }}>
        <AppAppBar />
        <Box
          id="hero"
          sx={(theme) => ({
            width: '100%',
            backgroundRepeat: 'no-repeat',
            backgroundImage:
              'radial-gradient(ellipse 80% 50% at 50% -20%, hsl(210, 100%, 90%), transparent)',
            ...theme.applyStyles('dark', {
              backgroundImage:
                'radial-gradient(ellipse 80% 50% at 50% -20%, hsl(210, 100%, 16%), transparent)',
            }),
          })}
        >
          <Box>
            <Stack
              spacing={2}
              sx={{
                alignItems: 'center',
                mx: 3,
                pb: 5,
                mt: { xs: 8, md: 0 },
              }}
            >
            </Stack>
            <Container
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                pt: 10,
                pb: { xs: 8, sm: 12 },
              }}
            >
              <Stack
                spacing={2}
                useFlexGap
                sx={{ alignItems: 'center', width: { xs: '100%', sm: '70%' } }}
              >
                <Typography
                  variant="h1"
                  sx={{
                    textAlign: 'center',
                    fontSize: '3rem',
                  }}
                >
                  Sobre&nbsp;
                  <Typography
                    component="span"
                    variant="h1"
                    sx={(theme) => ({
                      fontSize: 'inherit',
                      color: 'primary.main',
                      ...theme.applyStyles('dark', {
                        color: 'primary.light',
                      }),
                    })}
                  >
                    Nós
                  </Typography>
                </Typography>
              </Stack>
            </Container>
            <Container sx={{ display: 'flex', flexDirection: 'column', gap: 4, pl: '2 !important' }}>
              {/* Seção: Boas-vindas e descrição */}
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Typography variant="h4">
                  <strong>Boas vindas ao Nextalk - CABANA</strong><span style={{ fontWeight: 'normal' }}>LINK</span>
                </Typography>
                <Typography color="text.secondary" pl={2} pr={2}>
                  Somos uma equipe apaixonada por automação e atendimento digital. Criamos soluções de inteligência artificial, integradas ao WhatsApp, para que autônomos e pequenos negócios tenham um funcionário virtual 24/7, aumentando seu faturamento, evitando gargalos no suporte e elevando a experiência do cliente.
                </Typography>
              </Box>

              {/* Seção: Nossa Missão */}
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Typography variant="h6">
                  Nossa Missão
                </Typography>
                <Box
                  sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}
                  color='text.secondary'
                >
                  <Box pl={2} pr={2}>
                    <strong>Entregar automação acessível:</strong> Queremos que cada profissional autônomo tenha, sem complicações, uma solução de atendimento virtual que represente sua marca e esteja sempre disponível para seus clientes.
                  </Box>
                  <Box
                    sx={{
                      backgroundColor: mode === 'dark' || systemMode === 'dark'
                        ? 'hsl(208, 100.00%, 3.30%)'
                        : 'hsl(210, 100.00%, 96.90%)',
                      p: 2,
                      borderRadius: 1
                    }}
                  >
                    Simplificar processos e eliminar filas de espera, garantindo que nenhum cliente seja deixado sem resposta.
                  </Box>
                </Box>
              </Box>

              {/* Seção: Nossa Visão e Valores */}
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Typography variant="h6">
                  Nossa Visão e Valores
                </Typography>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                  <Stack color='text.secondary' sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                    <Typography variant="button" pl={2}>
                      <strong>Visão</strong>
                    </Typography>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                      <Typography pl={2}>
                        Ser referência em soluções de atendimento automático para WhatsApp, empoderando profissionais e empresas de pequeno porte a oferecer suporte de nível profissional, sem depender de grandes equipes.
                      </Typography>
                      <Box
                        sx={{
                          backgroundColor: mode === 'dark' || systemMode === 'dark'
                            ? 'hsl(208, 100.00%, 3.30%)'
                            : 'hsl(210, 100.00%, 96.90%)',
                          p: 2,
                          borderRadius: 1
                        }}
                      >
                        <Typography>Inovar constantemente, antecipando necessidades do mercado e entregando automação cada vez mais inteligente.</Typography>
                      </Box>
                    </Box>
                  </Stack>
                  <Stack color='text.secondary' sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                    <Typography variant="button" pl={2}>
                      <strong>Valores</strong>
                    </Typography>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                      <Typography pl={2}>
                        Transparência e ética em todas as interações, garantindo
                        segurança e confiança a cada usuário.
                      </Typography>
                      <Box
                        sx={{
                          backgroundColor: mode === 'dark' || systemMode === 'dark'
                            ? 'hsl(208, 100.00%, 3.30%)'
                            : 'hsl(210, 100.00%, 96.90%)',
                          p: 2,
                          borderRadius: 1
                        }}
                      >
                        <Typography>Foco no cliente: sua satisfação e resultados são nossos principais indicadores de sucesso.</Typography>
                      </Box>
                    </Box>
                  </Stack>
                  <Stack color='text.secondary' sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                    <Typography variant="button" pl={2}>
                      <strong>Compromisso</strong>
                    </Typography>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, pl: 2 }}>
                      <Typography>
                        Entregar suporte contínuo e atualizações frequentes, para que sua automação esteja sempre alinhada às melhores práticas do mercado.
                      </Typography>
                      <Typography>
                        Promover acessibilidade: cobrar preços justos e oferecer planos flexíveis pensados especialmente para pequenos negócios.
                      </Typography>
                    </Box>
                  </Stack>
                </Box>
              </Box>

              {/* Seção: Nossos Diferenciais */}
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Typography variant="h6">
                  Nossos Diferenciais
                </Typography>
                <Box
                  sx={{
                    backgroundColor: mode === 'dark' || systemMode === 'dark'
                      ? 'hsl(208, 100.00%, 3.30%)'
                      : 'hsl(210, 100.00%, 96.90%)',
                    p: 2,
                    borderRadius: 1,
                    color: 'text.secondary'
                  }}
                >
                  <Box sx={{ display: 'flex', gap: 1 }}>
                    <CheckCircleIcon sx={{ color: 'success.main', fontSize: 'medium', mt: 0.5 }} />
                    <Typography>
                      Projetado para eliminar filas e gargalos no atendimento, aumentando as suas conversões.
                    </Typography>
                  </Box>
                  <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
                    <CheckCircleIcon sx={{ color: 'success.main', fontSize: 'medium', mt: 0.5 }} />
                    <Typography>Atendimento 24/7 no WhatsApp, sem interrupções.</Typography>
                  </Box>
                  <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
                    <CheckCircleIcon sx={{ color: 'success.main', fontSize: 'medium', mt: 0.5 }} />
                    <Typography>Marca personalizada: o cliente conversa sempre com sua empresa, não com “ChatBot genérico”.</Typography>
                  </Box>
                </Box>
              </Box>

              {/* Seção: Nossa História */}
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Typography variant="h6">
                  Nossa História
                </Typography>
                <Typography color="text.secondary">
                  Fundada em 2022 a partir da experiência de atender pequenos negócios
                  que sofriam com atendimento lento e indisponibilidade no WhatsApp,
                  a <strong>CABANALINK</strong> rapidamente se preocupou em projetar a
                  ferramenta <i>Nextalk</i> afim de
                  entregar uma solução de qualidade, porém com um custo acessível,
                  visto que as opções do mercado eram inviáveis para o mircroempreendedor.
                  Hoje, continuamos a ampliar nosso leque de funcionalidades, integrando
                  ferramentas cada vez mais inteligentes e mantendo um suporte próximo
                  aos nossos clientes. Nosso objetivo para o futuro é
                  tornar a <i>Nextalk</i> a solução indispensável para qualquer profissional
                  autônomo que deseje elevar a qualidade do atendimento no WhatsApp.
                </Typography>
              </Box>
            </Container>
          </Box>
          <Divider sx={{ mt: 5 }} />
          <Footer />
        </Box>
      </Box>
    </>
  );
}
